import { ActionType } from "./action";

const initialState = {
  stack: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionType.SHOW: {
      const { allowDuplicate, ...modalProps } = action.props;
      const skipShowIfAlreadyVisible =
        allowDuplicate !== true && action.props.skipShowIfAlreadyVisible !== false;

      if (skipShowIfAlreadyVisible) {
        const isAlreadyVisible = state.stack.some(
          ({ component }) => component === action.component
        );

        if (isAlreadyVisible) {
          return state;
        }
      }

      return {
        ...state,
        stack: [
          ...state.stack,
          {
            id: new Date().valueOf(),
            component: action.component,
            props: modalProps,
            show: true
          }
        ]
      };
    }

    case ActionType.HIDE:
      const targetModalIndex = state.stack.findIndex(
        modal => modal.id === action.id
      );

      if (targetModalIndex === -1) {
        return state;
      }

      const stack = [...state.stack];

      stack[targetModalIndex].show = false;

      return {
        ...state,
        stack: stack
      };

    case ActionType.REMOVE:
      return {
        ...state,
        stack: state.stack.filter(modal => modal.id !== action.id)
      };

    case ActionType.REMOVE_BY_COMPONENT:
      return {
        ...state,
        stack: state.stack.filter(
          modal => modal.component !== action.component
        )
      };

    case ActionType.HIDE_ALL:
      return initialState;

    default:
      return state;
  }
}
